import { useErrorHandler, useHttpClient } from '@wix/fe-essentials/react';
import { useQueries } from '@wix/fe-essentials/react-query/react';
import _ from 'lodash';
import { useMemo } from 'react';
import { queryExecutionResultByItemType } from '../api/query-execution-result-by-item-type';
import { useGetItemTypeEntitiesSummaryAfterCrossPageCalculation } from '../components/verticals-drill-in-utils/use-get-entity-summary-after-cross-page-calculation';
import { QueryId } from '../queries';
import { isStaticPage } from '../rule-mappers/shared/helpers';
import { AnalysisState, usePanelStateAtom } from './rules-state';
import { useQueriesManager } from './use-queries-manager';
export const useQueriesExecutionResultsByItemType = tpaPageIds => {
  const {
    getGroupData,
    setGroupData,
    setGroupExecutionResults,
    setEntitiesSummaryAfterCrossPageCalculation
  } = usePanelStateAtom();
  const httpClient = useHttpClient();
  const errorHandler = useErrorHandler();
  const getItemTypeEntitiesSummaryAfterCrossPageCalculation = useGetItemTypeEntitiesSummaryAfterCrossPageCalculation();
  const queryConfigs = useMemo(() => tpaPageIds.map(tpaPageId => {
    var _groupData$analysisDa;
    const groupData = getGroupData(tpaPageId ?? '');
    const itemType = groupData == null ? void 0 : groupData.itemType;
    const analysisState = groupData == null ? void 0 : groupData.analysisState;
    const jobId = groupData == null || (_groupData$analysisDa = groupData.analysisData) == null ? void 0 : _groupData$analysisDa.analysisJobId;
    return {
      query: {
        enabled: Boolean(itemType) && Boolean(jobId) && !isStaticPage(itemType) && analysisState === AnalysisState.AnalyzeDonePendingResults,
        onError: () => {
          setGroupData(tpaPageId ?? '', {
            analysisState: AnalysisState.AnalyzeDoneFailedToFetchResults
          });
        },
        onSuccess: ruleExecutionResults => {
          const resultsGroupedByPageId = _.groupBy(ruleExecutionResults, 'metadata.pageId');
          Object.entries(resultsGroupedByPageId).forEach(_ref => {
            let [pageId, results] = _ref;
            setGroupExecutionResults(pageId, results);
          });
          const pageIdToStateMap = getItemTypeEntitiesSummaryAfterCrossPageCalculation(ruleExecutionResults, tpaPageId);
          setEntitiesSummaryAfterCrossPageCalculation(pageIdToStateMap, itemType);
        },
        queryFn: async () => {
          return queryExecutionResultByItemType(httpClient, itemType, errorHandler);
        },
        queryKey: [QueryId.QueryRuleExecutionResultsByJob, itemType, tpaPageId],
        refetchOnWindowFocus: false,
        retry: false
      },
      tpaPageId
    };
  }), [tpaPageIds, getGroupData, setGroupData, getItemTypeEntitiesSummaryAfterCrossPageCalculation, setEntitiesSummaryAfterCrossPageCalculation, setGroupExecutionResults, httpClient, errorHandler]);
  useQueries(queryConfigs.map(config => config.query));
  useQueriesManager(tpaPageIds);
};
//# sourceMappingURL=use-queries-execution-results-by-item-type.js.map